import About from "./component/About";
import { Contact } from "./component/Contact";
import Footer from "./component/Footer";
import Header from "./component/Header";
import Home from "./component/Home";
import MeetTheTeam from "./component/MeetTheTeam";
import Tour from "./component/Tour";
import Services from "./component/Services";
import VisionAndMission from "./component/VisionAndMission";
import WhyUs from "./component/WhyUs";
import "./style/App.css";
import { Routes, Route } from "react-router-dom";
import PageTransition from "./component/PageTransition";
import Value from "./component/Value";
import "./style/App.css";

function App() {
  return (
    <div>
      <PageTransition>
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/why-choose-us" element={<WhyUs />} />
          <Route path="/meet-our-team" element={<MeetTheTeam />} />
          <Route path="/vision" element={<VisionAndMission />} />
          <Route path="/tour" element={<Tour />} />
          <Route path="/value" element={<Value />} />
        </Routes>
        <Footer />
      </PageTransition>
    </div>
  );
}

export default App;
